export default __webpack_public_path__ + "assets/instructions/face_capture.png";